import React from "react";
import { Field, Formik } from "formik";
import { Dialog, Button, Radio } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile, updateUserInfo } from "../CrudAndRedux/ProfileCrud";
import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import convertPersianToEnglishNumber from "../../../utils/convert-persian-to-english-number";
import jalaali from "jalaali-js";
import fa from "moment/locale/fa";
import * as moment from "moment-jalaali";
import { Input } from "../../../../_metronic/_partials/controls";
import { actions as authActions } from "../../Auth/_redux/authRedux";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import fixNumbers from "../../../../functions/fixNumbers";
import isValidIranianNationalCode from "../../../../functions/nationalCodeValidation";

const PersonalInfo = (props) => {
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const birthDateConverter = (userDate) => {
    const persianDate = fixNumbers(
      new Date(userDate).toLocaleDateString("fa-IR")
    ).split("/");
    setSelectedDay({
      year: +persianDate[0],
      month: +persianDate[1],
      day: +persianDate[2],
    });
  };

  React.useEffect(() => {
    getUserProfile(authState.user.token).then((res) => {
      birthDateConverter(res.data.data.birthDate);
      dispatch(authActions.setUserInfo(res.data.data));
    });
  }, []);

  const [selectedDay, setSelectedDay] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [datepickerModal, setDatePickerModal] = React.useState(false);
  const [nationalCodeErr, setNationalCodeErr] = React.useState(null);

  const renderDatepickerCustomInput = ({ ref }) => {
    return (
      <>
        <input
          readOnly
          placeholder="تاریخ را انتخاب کنید"
          value={
            selectedDay
              ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
              : ""
          }
          ref={ref}
          style={{
            textAlign: "right",
            padding: "1.9rem 1rem",
            fontSize: "1rem",
            border: "1px solid #d9d9d9",
            width: "100%",
            borderRadius: "12px",
            color: "currentColor",
            height: "4rem",
            outline: "none",
            backgroundColor: "white",
          }}
          className="my-custom-input-class datepicker-scroll" // a styling class
          id="departuredDateRef"
        />
      </>
    );
  };

  const departuredDateRef = React.useRef(null);
  moment.locale("fa", fa);
  moment.loadPersian();
  const dispatch = useDispatch();
  const InputValue = React.useRef();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const timeManager = (time) => {
    if (time) {
      const persianDate = new Date(time).toLocaleDateString("fa-IR");
      return persianDate;
    }
  };

  return (
    <div
      style={{ border: "1px solid lightgray", borderRadius: 13 }}
      className="row flex-column bg-white shadow-sm p-5 mx-auto mt-13 text-right container"
    >
      <div
        className="d-flex justify-content-between justify-content-md-start align-items-baseline"
        style={{ paddingInline: "10px" }}
      >
        <h2 className="mb-7 mt-5" style={{ fontSize: "20px" }}>
          <b>مشخصات فردی</b>
        </h2>
        <span
          className="ml-5"
          style={{ color: "#6dd06d", cursor: "pointer", fontSize: 15 }}
          onClick={() => handleClickOpen()}
        >
          <i className="fa fa-edit" style={{ color: "#6dd06d" }}>
            {" "}
          </i>
          <span>
            <b> ویرایش</b>
          </span>
        </span>
      </div>
      <div className="d-block d-md-flex flex-wrap">
        {!authState.user ? null : (
          <>
            <div className="col-md-6 mab-1-8">
              <h3>
                <b className="font-16">نام و نام خانوادگی:</b>
                <span style={{ marginRight: 5 }} className="font-16">
                  {authState?.userInfo?.lastName &&
                    authState?.userInfo?.firstName ? (
                    `${authState?.userInfo?.firstName} ${authState?.userInfo?.lastName}`
                  ) : (
                    <>
                      {authState.user.user.firstName &&
                        authState.user.user.lastName
                        ? `${authState.user.user.firstName} ${authState.user.user.lastName}`
                        : "موجود نیست!"}{" "}
                    </>
                  )}
                </span>
              </h3>
            </div>
            <div className="col-md-6 mab-1-8">
              {" "}
              <h3>
                <b className="font-16">تاریخ تولد:</b>
                <span style={{ marginRight: 5 }} className="font-16">
                  {" "}
                  {authState?.userInfo?.birthDate
                    ? timeManager(authState?.userInfo?.birthDate)
                    : "موجود نیست!"}
                </span>
              </h3>
            </div>
            <div className="col-md-6 mab-1-8">
              {" "}
              <h3>
                {" "}
                <b className="font-16">کد ملی:</b>
                <span style={{ marginRight: 5 }} className="font-16">
                  {authState?.userInfo?.nationalCode
                    ? authState?.userInfo?.nationalCode
                    : "موجود نیست!"}
                </span>
              </h3>
            </div>
            <div className="col-md-6 mab-1-8">
              {" "}
              <h3>
                {" "}
                <b className="font-16">جنسیت:</b>
                <span style={{ marginRight: 5 }} className="font-16">
                  {" "}
                  {authState?.userInfo?.gender ||
                    authState?.userInfo?.gender === 0 ? (
                    <>{+authState?.userInfo?.gender === 0 ? "زن" : "مرد"}</>
                  ) : (
                    "موجود نیست !"
                  )}
                </span>
              </h3>
            </div>
          </>
        )}
      </div>
      <Dialog
        open={open}
        keepMounted
        fullScreen={isMobile ? true : false}
        PaperProps={{
          style: { height: "fit-content", overflow: "visible" },
        }}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        style={{ borderRadius: 20 }}
      >
        <div style={{ padding: 30 }}>
          <Formik
            enableReinitialize
            onSubmit={(values) => {

              const newDate = jalaali
                .jalaaliToDateObject(
                  selectedDay?.year,
                  selectedDay?.month,
                  selectedDay?.day
                )
                .toLocaleDateString()
                .split("/");

              const georgianDate = new Date(
                `${+newDate[2]}-${+newDate[0] < 10 ? `0${+newDate[0]}` : +newDate[0]
                }-${+newDate[1] < 10 ? `0${+newDate[1]}` : +newDate[1]}`
              );

              const year = georgianDate.getUTCFullYear();
              const month = georgianDate.getUTCMonth() + 1;
              const day = georgianDate.getUTCDate();
              const valMonth = month < 10 ? `0${month}` : month;
              const valDay = day < 10 ? `0${day}` : day;

              const userBirth = `${year}-${valMonth}-${valDay}`;

              values.birthDate = userBirth;
              console.log(values)
              if (!values.firstName || !values.lastName || !values.birthDate || !values.nationalCode) {
                setNationalCodeErr("لطفا اطلاعات را تکمیل کنید");
              }
              else if (isValidIranianNationalCode(values.nationalCode)) {
                values.nationalCode = values.nationalCode
                setNationalCodeErr(null);

                updateUserInfo(values, authState.user.token)
                  .then((res) => {
                    toast.success(
                      <span style={{ fontFamily: "sans" }}>
                        اطلاعات با موفقیت تغییر یافت
                      </span>
                    );
                    getUserProfile(authState.user.token).then((res) => {
                      dispatch(authActions.setUserInfo(res.data.data));
                    });
                  })
                  .catch((err) => {
                    toast.error(
                      <span style={{ fontFamily: "sans" }}>
                        مشکلی در ارتباط با سرور بوجود آمد
                      </span>
                    );
                  });
                handleClose();
              } else {
                console.log("b", isValidIranianNationalCode(values.nationalCode))
                setNationalCodeErr("کد ملی وارد شده صحیح نمی باشد!");
              }

            }}
            initialValues={authState?.userInfo ? authState?.userInfo : {}}
          >
            {({ handleSubmit, setFieldValue, values }) => {
              return (
                <>
                  <div className="row mb-4 mx-4">
                    <h3 className="">مشخصات فردی</h3>
                  </div>

                  <div className="row ">
                    <div
                      className="col-12 col-md-6 my-2"
                      style={{ height: "4rem" }}
                    >
                      <Field
                        name="firstName"
                        placeholder="نام"
                        onKeyUp={(e) => {
                          if (e.which === 13) {
                            document.getElementById("user-lastname").focus();
                          }
                        }}
                        className="w-100 h-100 fields-inputs p-3"
                        component={Input}
                        ref={InputValue}
                      />
                    </div>
                    <div
                      className="col-12 col-md-6 my-2"
                      style={{ height: "4rem" }}
                    >
                      <Field
                        name="lastName"
                        id="user-lastname"
                        onKeyUp={(e) => {
                          if (e.which === 13) {
                            document
                              .getElementById("user-nationalcode")
                              .focus();
                          }
                        }}
                        placeholder="نام خانوادگی"
                        className="w-100 h-100 fields-inputs p-3"
                        component={Input}
                        ref={InputValue}
                      />
                    </div>
                    <div
                      className="col-12 col-md-6  my-2"
                      style={{ height: "4rem" }}
                    >
                      <Field
                        name="nationalCode"
                        id="user-nationalcode"
                        onKeyUp={(e) => {
                          if (e.which === 13) {
                            document
                              .getElementById("departuredDateRef")
                              .focus();
                          }
                        }}
                        placeholder="کد ملی"
                        className="w-100 h-100 fields-inputs p-3"
                        component={Input}
                        ref={InputValue}
                      />

                    </div>
                    <div
                      className="col-12 col-md-6 my-2 d-flex align-items-center my-2"
                      style={{ height: "4rem" }}
                    >
                      <h6 className="mx-2">
                        <b>مرد</b>
                      </h6>
                      <Radio
                        checked={+values.gender === 1}
                        onChange={() => {
                          setFieldValue("gender", 1);
                        }}
                        style={{ color: "green" }}
                      />
                      <h6 className="mx-2">
                        <b>زن</b>
                      </h6>
                      <Radio
                        checked={+values.gender === 0}
                        style={{ color: "green" }}
                        onChange={() => {
                          setFieldValue("gender", 0);
                        }}
                      />
                    </div>
                    <div
                      className="col-12  my-2 d-flex align-items-center my-2"
                      style={{ height: "4rem" }}
                    >
                      {isMobile ? (
                        <input
                          onClick={() => {
                            setDatePickerModal(true);
                            // Scroll.scroller.scrollTo("datepicker-scroll", {
                            //   duration: 800,
                            //   delay: 0,
                            //   smooth: "easeInOutQuart",
                            // });
                          }}
                          readOnly
                          placeholder="تاریخ را انتخاب کنید"
                          value={
                            selectedDay
                              ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
                              : ""
                          }
                          renderDatepickerCustomInput
                          ref={departuredDateRef}
                          style={{
                            textAlign: "right",
                            padding: "1.9rem 1rem",
                            fontSize: "1rem",
                            border: "1px solid #d9d9d9",
                            width: "100%",
                            borderRadius: "13px",
                            color: "currentColor",
                            height: "4rem",
                            outline: "none",
                            backgroundColor: "white",
                          }}
                          className="my-custom-input-class datepicker-scroll" // a styling class
                          id="departuredDateRef"
                        />
                      ) : (
                        <DatePicker
                          value={selectedDay}
                          calendarPopperPosition="top"
                          onChange={(e) => {
                            setSelectedDay(e);
                          }}
                          name="departureDate"
                          ref={departuredDateRef}
                          shouldHighlightWeekends
                          renderInput={renderDatepickerCustomInput}
                          style={{ width: "100%" }}
                          locale="fa"
                        />
                      )}
                      {isMobile ? (
                        <Dialog
                          className="bg-white"
                          PaperProps={{
                            style: { borderRadius: "0" },
                            className: "datpicker-modal",
                          }}
                          fullScreen
                          open={datepickerModal}
                        >
                          <div className="d-flex flex-wrap px-5 py-2 bg-white">
                            <i
                              className="fa fa-times text-danger"
                              style={{ fontSize: "2rem" }}
                              onClick={() => {
                                setDatePickerModal(false);
                              }}
                            ></i>
                          </div>
                          <Calendar
                            calendarClassName={"modal-calendar"}
                            value={selectedDay}
                            onChange={(e) => {
                              setSelectedDay(e);
                              setDatePickerModal(false);
                            }}
                            style={{ height: "100%", width: "100%" }}
                            locale="fa"
                            shouldHighlightWeekends
                          />
                        </Dialog>
                      ) : null}

                    </div>

                    {nationalCodeErr ? (
                      <p
                        className="mt-3"
                        style={{ fontSize: "14px", color: "red" }}
                      >
                        {nationalCodeErr}
                      </p>
                    ) : null}

                  </div>

                  <div className="d-flex flex-wrap mt-4 justify-content-around">
                    <div
                      className="col-12 col-md-6 p-1 my-1"
                      style={{ height: "4rem" }}
                    >
                      <Button
                        className="w-100 h-100"
                        onClick={() => handleClose()}
                        style={{
                          border: "1px solid lightgray",
                          color: "white",
                          backgroundColor: "lightgray",
                          borderRadius: "13px",
                        }}
                      >
                        <h5 className="mx-auto my-auto text-white">
                          <b> انصراف</b>
                        </h5>
                      </Button>
                    </div>
                    <div
                      className="col-12 col-md-6 p-1 my-1"
                      style={{ height: "4rem" }}
                    >
                      <Button
                        className="w-100 h-100"
                        style={{
                          border: "1px solid #6dd06d",
                          color: "white",
                          backgroundColor: "#6dd06d",
                          padding: 6,
                          borderRadius: "13px",
                        }}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        <h5 className="mx-auto my-auto text-white">
                          <b>ثبت</b>
                        </h5>
                      </Button>
                    </div>
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </Dialog>
    </div>
  );
};

export default PersonalInfo;
